export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/vjXiwrYqNQ1RpV5B5eMAZQ/IMG_2727.jpg',
    alt: 'Sample page Power Travels Through Several Substations, tracing power from the power plant through step-up, transmission and distribution substations to consumers',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rmvnCep6e9DATiqQQavgnh/IMG_2728.jpg',
    alt: 'Sample page Distance Is a Safety System, explaining phase-to-earth, phase-to-phase and safety clearances and work and vehicle zones',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gsxnq5pEX3B7ioSXJJNDZo/IMG_2729.jpg',
    alt: 'Sample page The Substation Is Supervised Around the Clock, showing process, bay, station and control centre levels of SCADA',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cXSmdE87RhxsaYiuamkXsS/IMG_2730.jpg',
    alt: 'Sample page Voltage Depends on Reactive Power, covering the power triangle, capacitor banks, shunt reactors and static VAR compensators',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2uP6EF8QBETGawKketnnVA/IMG_2731.jpg',
    alt: 'Sample page Inside a Line Bay, showing the equipment sequence from incoming line to busbar',
  },
];
